import React, { useState } from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  IconAdd,
} from '../../components';

import css from './FAQPage.module.css';

import classNames from 'classnames';
import useMarketplaceConfigByLocation from '../../util/hooks/useMarketplaceConfigByLocation';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { LIST_FAQ_FINLAND, LIST_FAQ_SWEDEN, LIST_FAQ } from './data';
import { compose } from 'redux';

const FAQPageComponent = props => {
  const { intl } = props;
  const { currentCountryCode } = useMarketplaceConfigByLocation;
  const defaultListFaq =
    currentCountryCode === 'FI'
      ? LIST_FAQ_FINLAND
      : currentCountryCode === 'SE'
      ? LIST_FAQ_SWEDEN
      : LIST_FAQ;

  const [listFAQ, setListFAQ] = useState(defaultListFaq);

  const collapseBox = (boxIndex, questionIndex) => {
    const newList = [...listFAQ];
    newList[boxIndex].listQuestions[questionIndex].active = !newList[boxIndex].listQuestions[
      questionIndex
    ].active;
    setListFAQ(newList);
  };

  const title = intl.formatMessage({
    id: 'FAQPage.pageTitle',
  });

  const description = intl.formatMessage({
    id: 'FAQPage.pageDescription',
  });

  return (
    <StaticPage
      title={title}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQ Page',
        description: description,
        name: title,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="FAQPage.title" />
          </h1>
          {listFAQ.map((box, boxIndex) => (
            <div key={box.key} className={css.questionBox}>
              <div className={css.boxTitleWrapper}>
                <h2 className={css.boxTitle}>{box.title}</h2>
              </div>
              <div className={css.questionsList}>
                {box.listQuestions.map((q, questionIndex) => (
                  <div key={q.key} className={css.faqBox}>
                    <div
                      onClick={() => {
                        collapseBox(boxIndex, questionIndex);
                      }}
                      key={q.key}
                      className={css.question}
                    >
                      <p className={css.questionText}>{q.question}</p>
                      {q.active ? (
                        <p className={css.minus}>-</p>
                      ) : (
                        <IconAdd className={css.addIcon} />
                      )}
                    </div>
                    <div className={q.active ? classNames(css.answer, css.active) : css.answer}>
                      <p className={css.answerText}>{q.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const FAQPage = compose(injectIntl)(FAQPageComponent);

export default FAQPage;
